import { Routes } from '@angular/router';
import { PaymentComponent } from './components/payment/payment.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { CallbackComponent } from './components/callback/callback.component';
import { LegalNoticeComponent } from './pages/legal-notice/legal-notice.component';
import { PaymentVerificationComponent } from './components/payment-verification/payment-verification.component';
import { ErrorComponent } from './components/error/error.component';

export const routes: Routes = [
  {
    path: 'not-found',
    component: NotFoundComponent
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: 'legal-notice',
    component: LegalNoticeComponent
  },
  {
    path: 'success',
    component: PaymentVerificationComponent
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: ':paymendId',
    component: PaymentComponent
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];
